import { Navigate } from 'react-router-dom';
import { isPathbuddyHost } from '../../config/eduHost';
import MarketingLayout from './MarketingLayout';

function hostOf(hostname) {
  if (hostname !== undefined) return hostname;
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

export function HostGate({ legacy, children, hostname }) {
  if (isPathbuddyHost(hostOf(hostname))) {
    if (legacy) return legacy;
    return <Navigate to="/" replace />;
  }
  return <MarketingLayout>{children}</MarketingLayout>;
}

export function EduRedirect({ to, legacy, hostname }) {
  if (isPathbuddyHost(hostOf(hostname))) {
    if (legacy) return legacy;
    return <Navigate to="/" replace />;
  }
  return <Navigate to={to} replace />;
}
